import reducer from './reducer';
import { start } from './runGraphql';

export default {
  reducer,
  start,
};
